import { HOW_OFTEN_REACH_OUT_OPTIONS } from '../HOW_OFTEN_REACH_OUT_OPTIONS';
import { HowOftenReachOutOptionIdType } from '../types';

export const getHowOftenReachOutTitleById = (
  id: HowOftenReachOutOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    HOW_OFTEN_REACH_OUT_OPTIONS.find((option) => option.id === id)?.title ||
    null
  );
};

const DEFAULT: HowOftenReachOutOptionIdType = 'constant';
export const getHowOftenReachOutIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HowOftenReachOutOptionIdType | null => {
  const id = HOW_OFTEN_REACH_OUT_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
